import React from "react"
import { ImageMask } from "component/micro/design/ImageMask"
import { EColors, EFonts, EGrads, EHovers, EShadows } from "libs/style/styling"
import styled, { css } from "styled-components/macro"

interface Props {
  text: string
  type: "primary" | "secondary" | "primary2" | "white" | "acc2"
  shadow?: EShadows
  disabled?: boolean
  onClick?: () => void
  className?: string
}

export const MainButton = (props: Props): JSX.Element => {
  return (
    <S_MainButton
      className={props.className}
      onClick={props.onClick}
      type={props.type}
      shadow={props.shadow}
      disabled={props.disabled}
    >
      <span>{props.text}</span>
      {props.type === "acc2" && (
        <ImageMask
          randomizePosition={true}
          step={20}
          image="contour"
          repeat={true}
        />
      )}
    </S_MainButton>
  )
}

export const S_MainButton = styled.div`
  width: fit-content;
  cursor: pointer;
  box-shadow: ${props => props.shadow};
  position: relative;
  user-select: none;
  > span {
    z-index: 1;
    white-space: nowrap;
    font-family: ${EFonts.Medium};
  }
  ${props => {
    if (props.type === "primary") {
      return css`
        font-size: 14px;
        border-radius: 7px;
        padding: 10px 20px;
        @media only screen and (min-width: 1260px) {
          padding: 12px 30px;
          font-size: 18px;
        }
        ${props => {
          if (props.disabled) {
            return css`
              background: ${EColors.GREY3};
              cursor: not-allowed;
            `
          } else {
            return css`
              background: ${EGrads.ACC1_GRAD};
              color: ${EColors.DARK};
              &:hover {
                box-shadow: ${EHovers.LIGHT2}, ${props => props.shadow ?? "0 0"};
              }
            `
          }
        }};
      `
    } else if (props.type === "secondary") {
      return css`
        background-color: rgba(255, 255, 255, 0.08);
        color: ${EColors.ACC1_A};
        font-size: 14px;
        border-radius: 7px;
        padding: 10px 20px;
        &:hover {
          box-shadow: ${EHovers.LIGHT1}, ${props => props.shadow ?? "0 0"};
        }
        @media only screen and (min-width: 1260px) {
          padding: 12px 30px;
          font-size: 18px;
        }
      `
    } else if (props.type === "primary2") {
      return css`
        background: ${EGrads.ACC1_GRAD};
        color: ${EColors.DARK};
        font-size: 13px;
        border-radius: 50px;
        padding: 10px 20px;
        &:hover {
          box-shadow: ${EHovers.LIGHT2}, ${props => props.shadow ?? "0 0"};
        }
        @media only screen and (min-width: 1260px) {
          padding: 12px 30px;
          font-size: 16px;
        }
      `
    } else if (props.type === "white") {
      return css`
        background: ${EGrads.WHITE_GRAD};
        color: ${EColors.DARK};
        font-size: 12px;
        border-radius: 100px;
        padding: 8px 15px;
        &:hover {
          box-shadow: ${EHovers.DARK1}, ${props => props.shadow ?? "0 0"};
        }
        @media only screen and (min-width: 1260px) {
          padding: 10px 25px;
          font-size: 16px;
        }
      `
    } else if (props.type === "acc2") {
      return css`
        background: ${EGrads.ACC2_GRAD};
        color: ${EColors.WHITE};
        font-size: 12px;
        border-radius: 100px;
        padding: 8px 15px;
        &:hover {
          box-shadow: ${props => props.shadow ?? "0 0"};
        }
        @media only screen and (min-width: 1260px) {
          padding: 10px 25px;
          font-size: 16px;
        }
      `
    }
  }}
`
